import { Box } from "zmp-ui";

export const DisplayPrice = ({children}) => {
   return (
      <Box flex alignItems="baseline" className={`text-[#FF424E] text-[15px] font-semibold`}>
         {formatMoney(!!children ? children.toLocaleString() : 0)}₫
      </Box>
   );
};

export function formatMoney(money) {
   let str_money = new Intl.NumberFormat("vi-VN", {
      // style: "currency",
      // currency: 'VND',
   }).format(money);
   str_money = str_money.replace(/\./g, ",");
   return str_money;
}
